<template>
  <div id="subevent-add-update">
    <div class="content-wrapper">
      <div class="content animated fadeIn">
        <div class="row">
          <div class="col-md-12">
            <div class="card" style="margin-bottom: 9px;">
              <div class="card-body">
                <div class="row">
                  <div class="form-group col-md-12">
                    <label>{{this.$t('event.table.title')}}</label>
                    <el-input
                      placeholder
                      v-model="form.title"
                      :class="$inputError('title', validationErrors)"
                    ></el-input>
                    <span class="error">
                      {{ $errorMessage("title", validationErrors) }}
                    </span>
                  </div>
                </div>

                <div class="row">
                  <div
                    style="width: 100%; padding-bottom: 60%;  background-position: center; background-size: cover; position: relative; background-color: grey"
                    :style="'background-image: url(' + form.background + ')'"
                  >
                    <div
                      style="position: absolute;left: 0px; top: 0px;height: 100%; width: 100%; display: flex; flex: 1; align-items: center; flex-direction: column"
                    >
                      <div
                        class="banner"
                        style="height: 100px; width: 100%; background-size: contain; border: 1px solid #ddd; background-position: center; background-repeat: no-repeat"
                        :style="'background-image: url(' + form.top + ')'"
                      >
                        <el-upload
                          :onProgress="topProgress"
                          class="banner"
                          :action="
                            axios.defaults.baseURL +
                              'event/uploadImage?uploadType=liveTopBanner&language='+$i18n.locale
                          "
                          :headers="{
                            Authorization:
                              axios.defaults.headers['Authorization'],
                          }"
                          :show-file-list="false"
                          :on-success="topSuccess"
                        >
                          <span style="display: block">
                            {{this.$t('event.components.liveEventExp.nav.scenes.topBanner')}}
                            <br />
                            <span style="font-size: 14px;"
                              >
                              {{this.$t('event.components.liveEventExp.nav.scenes.topBannerDesc')}}
                              </span
                            >
                          </span>
                          <el-progress
                            :percentage="topPercent"
                            v-if="topPercent != 0"
                          ></el-progress>
                        </el-upload>
                      </div>

                      <div
                        style="display: flex; flex: 1; width: 100%; height: 100%"
                      >
                        <el-upload
                          :onProgress="backgroundProgress"
                          class="background"
                          :action="
                            axios.defaults.baseURL +
                              'event/uploadImage?uploadType=liveBackgroundBanner&language='+$i18n.locale
                          "
                          :headers="{
                            Authorization:
                              axios.defaults.headers['Authorization'],
                          }"
                          :show-file-list="false"
                          :on-success="backgroundSuccess"
                        >
                          <span style="display: block">
                            {{this.$t('event.components.liveEventExp.nav.scenes.background')}}
                            <br />
                            <span style="font-size: 14px"
                              >{{this.$t('event.components.liveEventExp.nav.scenes.backgroundDesc')}}</span
                            >
                          </span>
                          <el-progress
                            :percentage="backgroundPercent"
                            v-if="backgroundPercent != 0"
                          ></el-progress>
                        </el-upload>
                      </div>

                      <div
                        class="banner"
                        style="height: 100px; width: 100%; background-size: contain; border: 1px solid #ddd; background-position: center; background-repeat: no-repeat"
                        :style="'background-image: url(' + form.bottom + ')'"
                      >
                        <el-upload
                          :onProgress="bottomProgress"
                          class="banner"
                          :action="
                            axios.defaults.baseURL +
                              'event/uploadImage?uploadType=liveBottomBanner&language='+$i18n.locale
                          "
                          :headers="{
                            Authorization:
                              axios.defaults.headers['Authorization'],
                          }"
                          :show-file-list="false"
                          :on-success="bottomSuccess"
                        >
                          <span style="display: block">
                            {{this.$t('event.components.liveEventExp.nav.scenes.bottomBanner')}}
                            <br />
                            <span style="font-size: 14px;"
                              >{{this.$t('event.components.liveEventExp.nav.scenes.bottomBannerDesc')}}</span
                            >
                          </span>
                          <el-progress
                            :percentage="bottomPercent"
                            v-if="bottomPercent != 0"
                          ></el-progress>
                        </el-upload>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-12"
                  style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; padding: 0;
                  margin-top: 20px"
                >
                  <div v-if="form.id != null">
                    <el-popconfirm
                      @confirm="deleteItem"
                      :confirmButtonText="$t('event.variables.yes')"
                      :cancelButtonText="$t('event.buttons.cancel')"
                      icon="el-icon-info"
                      iconColor="red"
                      :title="$t('event.textbox.toDelete')"
                    >
                      <el-button
                        slot="reference"
                        type="danger"
                        icon="fas fa-trash"
                        >{{ $t('event.table.delete') }}</el-button
                      >
                    </el-popconfirm>
                  </div>
                  <div
                    class="text-right"
                    style="display: flex; flex: 1; align-items: center; justify-content: flex-end"
                  >
                    <el-button-group>
                      <el-button
                        type="warning"
                        @click="
                          $emit('closeMe');
                          showInfo = false;
                        "
                        >{{$t('event.buttons.close')}}</el-button
                      >
                      <el-button type="success" @click="save">{{$t("event.buttons.save")}}</el-button>
                    </el-button-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="form.id != null"
      @click="showInfo = !showInfo"
      style="display: flex; width: 100%; align-items: center; justify-content: center; cursor: pointer; padding: 10px 0px"
    >
      <i :class="!showInfo ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
    </div>
    <transition name="slide-fade">
      <ItemInfo :data="form" v-if="showInfo" />
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import ItemInfo from "./ItemInfo";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import moment from "moment";

import { quillEditor } from "vue-quill-editor";
export default {
  components: { ItemInfo, quillEditor },
  name: "SubEventAddUpdate",
  props: ["data"],
  mounted() {
    this.$store.dispatch("getVenues");
  },
  data() {
    return {
      form: {
        id: null,
        title: null,
        top: null,
        bottom: null,
        background: null,
      },
      topPercent: 0,
      bottomPercent: 0,
      backgroundPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false,
      moment,
    };
  },
  methods: {
    deleteItem() {
      var index = this.$store.state.scenes.items.findIndex(
        (k) => k.id == this.form.id
      );
      if (index != -1) {
        this.$emit("deleteMe", index);
        this.$emit("closeMe");
      }
    },
    save() {
      this.validationErrors = [];
      axios
        .post("scene/addorupdate", {
          ...this.form,
        })
        .then((res) => {
          this.validationErrors = res.data.validationErrors;
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
            if (this.form.id == null) {
              this.$emit("itemAdded", res.data.data);
              this.form = {
                id: null,
                title: null,
                top: null,
                bottom: null,
                background: null,
              };
            } else {
              this.$emit("itemUpdated", JSON.parse(JSON.stringify(this.form)));
              if (this.showInfo) {
                this.showInfo = false;
                setTimeout(() => {
                  this.showInfo = true;
                }, 350);
              }
            }
          }
        });
    },
    topProgress(event) {
      this.topPercent = event.percent;
    },
    topSuccess(response) {
      this.topPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.top = response.data;
      }
    },
    bottomProgress(event) {
      this.bottomPercent = event.percent;
    },
    bottomSuccess(response) {
      this.bottomPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.bottom = response.data;
      }
    },
    backgroundProgress(event) {
      this.backgroundPercent = event.percent;
    },
    backgroundSuccess(response) {
      this.backgroundPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.background = response.data;
      }
    },
  },
  watch: {
    data: function(newVal) {
      this.showInfo = false;
      if (newVal != undefined && newVal != null) {
        this.form = {
          ...this.data,
        };
        this.validationErrors = [];
      } else {
        this.form = {
          id: null,
          title: null,
          top: null,
          bottom: null,
          background: null,
        };
      }
    },
  },
  created() {
    if (this.data != undefined && this.data != null) {
      this.form = {
        ...this.data,
      };
    }
  },
};
</script>

<style>
.banner {
  height: 100px;
  width: 100%;
}

.banner .el-upload {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 20px;
  color: white;
  text-shadow: 0px 0px 5px rgba(0, 0, 0, 1);
  flex-direction: column;
}

.background {
  width: 100%;
}

.background .el-upload {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 20px;
  color: white;
  text-shadow: 0px 0px 5px rgba(0, 0, 0, 1);
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/SceneAddUpdate.vue